import {AssertWarn} from "js-vextensions";
import {CreateAccessor} from "mobx-graphlink";

let textMeasurementCanvas: HTMLCanvasElement;
let textMeasurementCanvasContext: CanvasRenderingContext2D;
export function GetTextWidth(text: string, font: string) {
	// re-use canvas object for better performance
	const canvas = textMeasurementCanvas ?? (textMeasurementCanvas = document.createElement("canvas"));
	const context = textMeasurementCanvasContext ?? (textMeasurementCanvasContext = canvas.getContext("2d")!);

	context.font = font;
	// if context's font doesn't match what we just set, warn (can mean invalid font was passed, making return-value inconsistent since context is re-used)
	// (before comparing, we remove the font-weight "normal/400" prefix from provided value [if present], since it gets removed as redundant by browser)
	AssertWarn(context.font == font.replace(/^(normal |400 )/, ""), `Failed to set font. @tried(${font}) @result(${context.font})`);

	const metrics = context.measureText(text);
	return metrics.width;
}

export function GetCSSStyle(element: HTMLElement, prop: string) {
	return window.getComputedStyle(element, null).getPropertyValue(prop);
}
export const GetCanvasFont = CreateAccessor((fontSize?: string, fontFamily?: string, fontWeight?: number, elForValFallbacks: HTMLElement = document.body, checkIfFontLoaded = true)=>{
	const fontSize_final = fontSize || GetCSSStyle(elForValFallbacks, "font-size") || "14px";
	const fontFamily_final = fontFamily || GetCSSStyle(elForValFallbacks, "font-family") || "Arial, sans-serif";
	const fontWeight_final = fontWeight || GetCSSStyle(elForValFallbacks, "font-weight") || "normal";
	const result = `${fontWeight_final} ${fontSize_final} ${fontFamily_final}`;

	// check if the browser has finished loading the fonts in question; if not, log a warning
	const fontsExcludingOptional = result.replace(", AdobeNotDef", ""); // takes 0-0.2ms, according to performance.now() [generally says 0.1ms]
	if (checkIfFontLoaded && !document.fonts.check(fontsExcludingOptional)) {
		console.warn(`
			At time of GetCanvasFont being called, the provided fonts had not finished loading: ${fontsExcludingOptional}
			This can cause incorrect text-measurement, causing display bugs. Did you forget to update the font usages in container "hidden_early" of index.html, to trigger early font-loading?
		`);
	}

	return result;
});